import React, { useEffect, useState } from "react";
import {useNavigate} from 'react-router-dom';

import Parametri from './parametri';
import logoAIG from './immagini/AIG-piccolo.png';
import SezioneHome from './SezioneHome'
import SezioneDettaglio from './SezioneDettaglio'
import MenuAlto from './menuAlto'
import IntroHome from './IntroHome'
import Intestazione from './intestazione'
import FondoPagina from './fondoPagina'
import ProvaGratis from './ProvaGratis'
import Acquista from './Acquista'
import Prezzi from './Prezzi'
import ChiSiamo from './chisiamo'
import ScaricaApp from './ScaricaApp'

const packageJson = require('../package.json');

const produttore = {"ragioneSociale":"AIG Azienda Informatica Genova S.r.l.", "pIva":"02927720991"};

function PaginaPrincipale(props) {
    const [dimensioniApp, setDimensioniApp] = useState({x: 0, y:0, flagPaginaOrizzontale:false});
    const altezzaContenitoreHome = 320;
    const larghezzaMinimaPerPaginaOrizzontale = 800;    
    const comandoNavigazione = useNavigate();

    const sezioniHome = [
        {
            titolo: "Tutto sotto controllo",
            descrizione: "Controlla <strong>scadenze</strong>, <strong>certificati</strong> e <strong>pagamenti</strong> in un’unica schermata.<br/>Invia in automatico notifiche agli atleti con le loro scadenze.",
            immagine: require("./immagini/homeScadenze.png"),
            link: "/scadenze"
        },
        {
            titolo: "Prenotazioni veloci",
            descrizione: "Gli atleti possono <strong>prenotare lezioni e/o attrezzature</strong> (ad esempio un campo) direttamente dal loro <strong>smartphone</strong>.",
            immagine: require("./immagini/homePrenotazioni.png"),
            link: "/prenotazioni"
        },
        {
            titolo: "Eventi e convocazioni",
            descrizione: "Incontri, manifestazioni, allenamenti: invia le <strong>convocazioni</strong> con un click.<br/>Per ogni evento si crea una <strong>chat</strong> tra lo staff e i convocati.<br/>Gestisci le <strong>presenze</strong> e i <strong>risultati</strong>.",
            immagine: require("./immagini/homeEventi.jpeg"),
            link: "/eventi"
        },
        {
            titolo: "Allenamenti",
            descrizione: "Crea <strong>schede allenamenti</strong> predefinite e personalizzate, ogni atleta le avrà nel suo smartphone.",
            immagine: require("./immagini/homeAllenamenti.png"),
            link: "/allenamenti"
        },
        {
            titolo: "Gestione economica",
            descrizione: "Incassi, spese, rimborsi, sponsor: gestione facile e report chiari.<br/><strong>Ricevute personalizzabili</strong> e subito disponibili per gli atleti e/o fatture elettroniche.<br/>Consulta e esporta in Excel la <strong>Prima Nota</strong> che si genera automaticamente.",
            immagine: require("./immagini/homePrimaNota.png"),
            link: "/gestioneEconomica"
        },
        {
            titolo: "Comunicazioni",
            descrizione: "Invia comunicazioni e avvisi agli iscritti.",
            immagine: require("./immagini/homeNews.png"),
            link: "/news"
        },
        {
            titolo: "Report",
            descrizione: "Genera tanti report con tabelle e grafici per tenere tutto sotto controllo: bilancio, insolventi, prenotazioni, risultati sportivi, tesseramenti,...",
            immagine: require("./immagini/homeReport.png"),
            link: "/report"
        },
        {
            titolo: "Anagrafiche",
            descrizione: "Gestisci soci, atleti, direttivo, fornitori, federazioni, <strong>tesseramenti</strong>, enti esterni, società analoghe, contatti utili.<br/>Gestisci i rapporti con genitori o altri riferimenti degli iscritti.<br/>Se hai già questi dati in formato informatico, puoi inserirli automaticamente con una importazione di dati.",
            immagine: require("./immagini/homeAnagrafiche.png"),
            link: "/anagrafiche"
        },
        {
            titolo: "Moduli precompilati",
            descrizione: "Genera documenti precompilati, per esempio la domanda di iscrizione, dai dati inseriti in anagrafica.<br/>Anche con gestione dei minorenni, dove le dichiarazioni sono fatte dai loro referenti.",
            immagine: require("./immagini/modulisticaprecompilata.png"),
            link: "/modulisticaprecompilata"
        },    
        {
            titolo: "Controllo Accessi",
            descrizione: "Gestisci l'accesso alle tue strutture, con o senza tornelli, con lettori di schede RFID o QRCode.",
            immagine: require("./immagini/homeControlloAccessi.png"),
            link: "/qrcode"
        },    
        {
            titolo: "Importazione ed esportazione massiva dei dati",
            descrizione: "Inserisci i dati dal tuo vecchio gestionale o dai tuoi fogli Excel con inserimento massivo.<br/>Esporta in formato Excel i dati delle tabelle.",
            immagine: require("./immagini/importexportgs.png"),
            link: "/estrazione"
        },    
        {
            titolo: "Manda mail dal tuo dominio",
            descrizione: "Se vorrai, potrai far arrivare ai tuoi iscritti le mail generate da Gestione Sportiva da un tuo indirizzo di posta elettronica, automaticamente, per una migliore immagine verso i tuoi clienti.",
            immagine: require("./immagini/mailTuoDominio2.png"),
            link: "/mail"
        },
        {
            titolo: "Sicurezza, semplicità e assistenza",
            descrizione: "Non devi installare nulla: ti basta un collegamento a Internet, puoi usare qualunque PC o tablet per accedere.<br/>Non sei mai da solo: per qualunque suggerimento su come utilizzare il programma, saremo sempre al tuo fianco.",
            immagine: require("./immagini/sicurezzaSemplicitaAssistenza.png"),
            link: "/sicurezza"
        },
        {
            titolo: "Personalizzazioni",
            descrizione: "Le società e le associazioni sono tutte diverse, ognuno di noi utilizza i programmi in modo diverso.<br/>Per questo, Gestione Sportiva si adatta a te!<br/>Contattaci e potremo personalizzare GestioneSportiva sulle tue esigenze.",
            immagine: require("./immagini/personalizzazioni.png"),
            link: "/personalizzazioni"
        },
        {
            titolo: "Prezzi",
            descrizione: "Gestione Sportiva ha un imbattibile rapporto prezzo/qualità. Scopri il listino cliccando il bottone qui sotto e contattaci per ottenere codici <strong>sconto</strong>.<br/>Potrai pagare con PayPal, carta di credito o bonifico bancario.",
            immagine: require("./immagini/prezzi.png"),
            link: "/prezzi"
        },
    ]; 

    const versioneCorrenteNonAggiornata = (ultimaVersione, versioneCorrente) => {
        const versionsA = ultimaVersione.split(/\./g);
      
        const versionsB = versioneCorrente.split(/\./g);
        while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());
      
        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
        }
        return false;
    };

    function ControlloVersione() {        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"versione"})
        };
      
        fetch(Parametri("serverURL"), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {          
                if(valoreDiRitorno.risultatoOperazione===1){
                    //alert("controlloVersione2: a="+a+" back="+valoreDiRitorno.versione+" package="+packageJson.version);
                    if (versioneCorrenteNonAggiornata(valoreDiRitorno.versione, packageJson.version)) {
                        window.location.reload(true);
                    }
                }
            },
            (error) => {
                // se va in error non ricarico altrimenti la fa all'infinito. Potrei indicare errore ma forse è meglio tenersi la pagina non aggiornata...
                //window.location.reload(true);
            }
        ); 
    }

    function PaginaSecondaria(props) {
        return (
            <div className='App'>     
                <MenuAlto {...props} bottoneHome={true}/>
                <Intestazione {...props} titoloPagina={props.titoloPagina}/>

                {props.sottotitoloPagina && 
                    <div
                        style={{ lineHeight: 2, marginTop: 20, marginBottom: 60, fontStyle: "italic" }}
                        dangerouslySetInnerHTML={{ __html: props.sottotitoloPagina }}
                    />
                }

                {props.sezioni.map((sezione, index) => (
                    <SezioneDettaglio
                        key={index}
                        {...props}
                        titolo={sezione.titolo}
                        descrizione={sezione.descrizione}
                        tipoContenuto={sezione.tipoContenuto}
                        urlContenuto={sezione.urlContenuto}
                    />
                ))}
                
                {props.noteFinePagina && 
                    <div 
                        style={{marginBottom:20, marginLeft:10, marginRight: 10, fontSize:14}}
                        dangerouslySetInnerHTML={{ __html: props.noteFinePagina }}
                    />
                }

                <FondoPagina {...props} produttore={produttore}/>
            </div>
        )
    }

    useEffect(() => {       
        window.scrollTo(0, 0);

        ControlloVersione();
        
        const calcolaDimensioniApp = () => {      
            setDimensioniApp({x:document.documentElement.clientWidth, y:document.documentElement.clientHeight, flagPaginaOrizzontale:document.documentElement.clientWidth>larghezzaMinimaPerPaginaOrizzontale});
        }
        
        calcolaDimensioniApp();
        window.addEventListener('resize', calcolaDimensioniApp);
        
        return () => {
            window.removeEventListener('resize', calcolaDimensioniApp);
        };
    }, []);

    function vaiLink(link) {
        comandoNavigazione(link);
        window.scrollTo(0, 0);
    }        

    if (props.pagina==="eventi") {
        const titoloPagina = "Eventi";
        const separatore = dimensioniApp.flagPaginaOrizzontale ? ": " : "<br/>";
        const sottotitoloPagina = "Incontri, raduni, allenamenti"+separatore+"gestirli non è mai stato così facile";
        const sezioni = [
        {
            titolo: "Crea",
            descrizione: "Crea un nuovo evento, da pc o smartphone.<br/>Un evento può essere un allenamento, una gara, una manifestazione, qualunque tipo di incontro<br/>Vuoi creare un evento tante volte, per esempio un allenamento settimanale? Basta un click per replicarlo quante volte vuoi.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"EventiCreaNuovo.png"
        },
        {
            titolo: "Convoca",
            descrizione: "Convoca gli atleti, che riceveranno un avviso sul loro smartphone e indicheranno se saranno presenti con un semplice click. Tu vedrai in tempo reale chi ha aderito.<br/>Puoi convocare i singoli atleti o selezionarli per gruppi (es. Under14, Under16, Under18,...).",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"EventiConvoca.png"
        },
        {
            titolo: "Scrivi messaggi a tutti",
            descrizione: "Invia un messaggio a tutti i convocati in una chat dedicata all'evento, che si crea automaticamente e dove ci sono già tutti i convocati",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"EventiChat1.png",
        },
        {
            titolo: "Scrivi messaggi a un convocato",
            descrizione: "Invia un messaggio a un solo convocato: solo lui potrà vederlo e potrà decidere se rispondere allo staff o a tutti",
            tipoContenuto: "mp4",
            urlContenuto: props.urlMultimedia+"EventiChat2.mp4"
        },
        {
            titolo: "Presenze",
            descrizione: "Registra chi è stato presente all'evento",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"EventiPresenze.png"
        },
        {
            titolo: "Risultati e Report",
            descrizione: "Registra i risultati dell'evento<br/>Ottieni i report delle presenze e dei risultati: su app, su web o generando un pdf stampabile",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"EventiReport.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="prenotazioni") {
        const titoloPagina = "Prenotazioni";
        const sottotitoloPagina = "Prenotazioni di corsi, campi, sale, attrezzature";
        const sezioni = [
        {
            titolo: "Crea",
            descrizione: "Definisci corsi e attrezzature prenotabili.<br/>Imposta, per ciascun corso, gli orari e il numero di posti disponibili",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"PrenotazioniNuovo.png"
        },
        {
            titolo: "Prenota da smartphone",
            descrizione: "Gli iscritti prenotano in autonomia:<br/>selezionano cosa prenotare, ottengono il calendario con gli orari disponibili e indicazione dei posti rimasti in tempo reale, prenotano e disdicono (se la prenotazione non è troppo vicina nel tempo)",
            tipoContenuto: "mp4",
            urlContenuto: props.urlMultimedia+"PrenotazioniApp.mp4"
        },
        {
            titolo: "Prenota da web",
            descrizione: "Inserisci prenotazioni da web selezionando l'iscritto e il corso da prenotare, per gli iscritti che si prenotano telefonicamente o si presentano personalmente",
            tipoContenuto: "mp4",
            urlContenuto: props.urlMultimedia+"PrenotazioniWeb.mp4"
        },
        {
            titolo: "Verifica",
            descrizione: "Ottieni il report delle prenotazioni, nella pagina web o in pdf scaricabile e stampabile",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"PrenotazioniReport.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="allenamenti") {
        const titoloPagina = "Allenamenti";
        const sottotitoloPagina = "";
        const sezioni = [
            {
                titolo: "Inserisci gli esercizi",
                descrizione: "Inserisci gli esercizi, da web o da app, se vuoi dividendoli per classificazione (braccia, gambe, addominali,...), con tutte le istruzioni.<br/>Aggiungi un'immagine all'esercizio, anche direttamente dalle foto che hai nel tuo telefono.",
                tipoContenuto: "png",
                urlContenuto: props.urlMultimedia+"AllenamentiModificaEsercizio.png",
            },
            {
                titolo: "Crea e assegna le schede",
                descrizione: "Crea le schede, da web o da app, per i diversi tipi di allenamento e poi assegnale ai singoli iscritti, eventualmente personalizzando qualche dato o aggiungendo note specifiche per il singolo atleta",
                tipoContenuto: "png",
                urlContenuto: props.urlMultimedia+"AllenamentiModificaScheda.png"
            },
            {
                titolo: "Scorri una scheda sullo smartphone",
                descrizione: "L'atleta visualizza le schede che l'allenatore gli ha assegnato, visualizza gli esercizi uno per schermata, con le istruzioni e le immagini",
                tipoContenuto: "mp4",
                urlContenuto: props.urlMultimedia+"AllenamentiScheda.mp4"
            },
            {
                titolo: "Stampa una scheda",
                descrizione: "Genera un PDF con la scheda, scelta tra quelle predefinite o quelle assegnate agli atleti, per inviarlo o stamparlo",
                tipoContenuto: "png",
                urlContenuto: props.urlMultimedia+"AllenamentiSchedaPdf.png"
            }
        ]
        const noteFinePagina = 'Puoi caricare le immagini che preferisci, eventualmente prelevandole dalla Galleria del telefono.<br/>Le immagini di questa pagina sono <a href="http://www.freepik.com">Designed by grmarc / Freepik</a>';
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} noteFinePagina={noteFinePagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="gestioneEconomica") {
        const titoloPagina = "Gestione Economica";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Quote associative e abbonamenti",
            descrizione: `Rinnova o assegna un nuovo abbonamento con un click<br/>
            Inserisci l'incasso di quote associative e abbonamenti, anche pagamenti rateali<br/>
            Controlla la situazione debitoria dell'iscritto<br/>
            Genera una ricevuta pdf da dare al socio o all'abbonato (che può portarla al proprio commercialista), con eventuale precisazione di chi ha effettuato il pagamento se l'iscritto è minore<br/>
            Genera una fattura elettronica verso i soci e gli abbonati`,
            tipoContenuto: "mp4",
            urlContenuto: props.urlMultimedia+"GestioneEconomicaQuote.mp4"
        },{
            titolo: "Spese",
            descrizione: "Inserisci le spese, anche rateali",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"GestioneEconomicaSpese.png",
        },{
            titolo: "Incassi da sponsor, enti esterni",
            descrizione: "Inserisci gli incassi da enti esterni (sponsor) e genera una ricevuta pdf, utile anche per generare i CUD",
            tipoContenuto: "mp4",
            urlContenuto: props.urlMultimedia+"GestioneEconomicaIncassiEsterni.mp4"
        },{
            titolo: "Rimborsi e incassi da iscritti",
            descrizione: "Inserisci i rimborsi dati agli iscritti o incassi diversi ricevuti da iscritti",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"GestioneEconomicaIncassiIscritti.png"
        },{
            titolo: "Prima Nota",
            descrizione: "Ottieni l'elenco di tutti i movimenti in entrata e in uscita dell'anno, nella Prima Nota che viene automaticamente compilata quando inserisci incassi, spese, rimborsi, ecc.<br/>Aggiungi direttamente voci in Prima Nota, se non si riconducono ai casi previsti",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"GestioneEconomicaPrimaNota.png"
        },{
            titolo: "Risorse e voci di bilancio",
            descrizione: "Per ogni entrata ed ogni uscita, definisci la risorsa (cassa, conto bancario,...) e la voce di bilancio (acquisti, affitto, quote soci, quote abbonamento,...) che comparirà nel report di bilancio",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"GestioneEconomicaRisorseVociBilancio.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="scadenze") {
        const titoloPagina = "Scadenze";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Scadenze nella Home Page",
            descrizione: "Controlla le scadenze di tutta la società semplicemente dalla Home Page dell'applicazione: documenti in scadenza, pagamenti da effettuare, qualunque adempimento che puoi inserire in uno scadenziario",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ScadenzeHome.png"
        },{
            titolo: "Scadenze sullo smartphone",
            descrizione: "L'iscritto ha sempre indicazione delle proprie scadenze, dei documenti e dei pagamenti e ha il dettaglio dei movimenti: importi da pagare, importi pagati e ricevute",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ScadenzeApp.png"
        },{
            titolo: "Situazione Dettagliata Iscritti",
            descrizione: "Ottieni l'elenco degli insolventi e la situazione dettagliata di un singolo iscritto, che sia socio o che sia abbonato",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ScadenzeDettaglioInsolvente.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="news") {
        const titoloPagina="Comunicazioni"
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Bacheca News",
            descrizione: "Pubblica comunicazioni nella bacheca della società: gli iscritti riceveranno una notifica e leggeranno le news con il loro smartphone",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"news.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="report") {
        const titoloPagina = "Report";
        const sottotitoloPagina = "Report a video o in PDF, per inviarli o stamparli,<br/>per tenere tutto sotto controllo";
        const sezioni = [
        {
            titolo: "Report Prenotazioni",
            descrizione: "Elenco delle prenotazioni, filtrando per corso o attrezzatura e/o per l'iscritto che ha prenotato.<br>Report in formato tabellare (esportabile in PDF) o grafico.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportPrenotazioni.png"
        },{
            titolo: "Report Insolventi Quote",
            descrizione: "Elenco dei soci e degli abbonati che hanno quote da pagare",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportInsolventi.png"
        },{
            titolo: "Report Bilancio",
            descrizione: "Report di bilancio con le sezioni:<br/>- Liquidità, crediti e debiti a inizio anno<br/>- Entrate e uscite raggruppate per voce di bilancio<br/>- Liquidità, crediti e debiti a fine anno<br/>- Elenco movimenti<br/>- Elenco soci.<br/>Scegli tu quali sezioni inserire nel report.<br/>Per ogni sezione, scegli se vuoi tabelle e/o grafici e il tipo di grafico (barre, torta,...).<br/>Scegli quali importi visualizzare (lordi, netti, iva).<br/>Scegli se calcolare sull'anno solare o sull'anno di esercizio (se non coincidono).<br/>Il sistema ricorda le impostazioni per i report seguenti.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportBilancio.png"
        },{
            titolo: "Scadenze certificati medici",
            descrizione: "Iscritti con certificato medico scaduto o in scadenza",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportScadenzeCertificati.png"
        },{
            titolo: "Scadenze documenti",
            descrizione: "Iscritti con documento di identità scaduto o in scadenza",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportScadenzeDocumenti.png"
        },{
            titolo: "Scadenze tesseramenti",
            descrizione: "Tesseramenti presso Federazioni o altri enti, in scadenza",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportScadenzeTesseramenti2.png"
        },{
            titolo: "Scadenze vincoli",
            descrizione: "Vincoli sportivi in scadenza",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportScadenzeVincoli.png"
        },{
            titolo: "Situazione economica iscritti",
            descrizione: "Incassi e rimborsi degli iscritti",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportSituazioneEconomicaIscritti.png"
        },{
            titolo: "Situazione economica esterni",
            descrizione: "Situazione delle spese effettuate dai fornitori e degli incassi ricevuti dagli enti esterni",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportSituazioneEconomicaEsterni.png"
        },{
            titolo: "Report sponsor",
            descrizione: "Sponsorizzazioni ricevute",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportSponsor.png"
        },{
            titolo: "Report rimborsi",
            descrizione: "Rimborsi erogati",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportRimborsi.png"
        },{
            titolo: "Report eventi",
            descrizione: "Report Presenze o Risultati per lo Staff, aggregati per gruppo (es. under16, under18,...) e/o tipo di evento oppure per singolo atleta.<br/>Su PC o su smartphone",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportEventi2.png"
        },{
            titolo: "Report elenco articoli", 
            descrizione: "Elenco articoli del merchandizing, con indicazione delle giacenze e della disponibilità alla vendita",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"ReportArticoli.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }    

    if (props.pagina==="anagrafiche") {
        const titoloPagina = "Anagrafiche";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Tabelle",
            descrizione: "Gestisci tutte le anagrafiche ti servono:<br/>- Iscritti (soci e abbonati),<br/>- Direttivo,<br/>- Libro Soci,<br/>- Enti esterni e fornitori,<br/>- Contatti utili e società analoghe,<br/>- Tesseramenti,<br/>- Federazioni,<br/>sempre con possibilità di ricerca e ordinamento su più colonne",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"anagrafiche.png"
        },{
            titolo: "Inserisci automaticamente i dati",
            descrizione: "Hai già i dati in formato informatico?<br/>Attraverso un potente importatore, puoi inserirli automaticamente in Gestione Sportiva!<br/>L'importatore può leggere abbonamenti, abbonati, adempimenti, articoli, contatti, fornitori, esercizi, soci, movimenti economici, corsi, attrezzature, raggruppamenti, risorse, sponsor, tesseramenti, voci di bilancio e altro ancora.<br/><strong>Pensi sia complicato?</strong> Contattaci! <strong>Possiamo aiutarti</strong> a fare l'inserimento massivo dei dati, elaboriamo noi i tuoi file.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"AnagraficheImportatore.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="modulisticaprecompilata") {
        const titoloPagina = "Moduli Precompilati";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Moduli precompilati",
            descrizione: "Genera documenti precompilati con i dati in anagrafica e il testo che vuoi tu.<br/>Con gestione automatica dei minorenni, intestando il modulo al maggiorenne che lo firma.",
            immagine: "imgModulisticaPrecompilata"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="qrcode") {
        const titoloPagina="Controllo Accessi";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Controllo Accessi",
            descrizione: "Gestione Sportiva si integra con i sistemi per gestire gli accessi alla tua struttura.<br/>Gli accessi possono avvenire usando tessere (RFID o con QRCode) o la APP (QRCode).<br/>Se hai già tornelli e lettori di schede, potrai mantenerli e farli funzionare con Gestione Sportiva.<br/>Il sistema è totalmente personalizzabile: potrai decidere chi può accedere (i soci, gli abbonati con abbonamento valido per la struttura o per uno specifico corso), quando può accedere (orari di apertura), con quali modalità (scheda o qrcode su smartphone).<br/>Avrai un report in tempo reale degli accessi di ciascun iscritto.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"Tessere.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="mail") {
        const titoloPagina = "Invio Email";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Manda mail dal tuo dominio",
            descrizione: "Gestione Sportiva invia mail ai tuoi iscritti, per esempio per mandare loro i dati per accedere all'applicazione.<br/>Se lo desideri, Gestione Sportiva potrà mandare queste email da un tuo indirizzo di posta elettronica, per una migliore immagine verso i tuoi clienti",
            tipoContenuto: "png",
            urlContenuto: require("./immagini/mailTuoDominio2.png")
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)        
    }

    if (props.pagina==="sicurezza") {
        const titoloPagina = "Sicurezza e Assistenza";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Sicurezza, semplicità e assistenza",
            descrizione: "Puoi usarlo da dove vuoi, con un semplice browser da qualunque computer, sempre con la versione aggiornata.<br/>E iscritti ed allenatori accedono facilmente con icona nel loro telefono, grazie alla Web APP.<br/>Tutto in sicurezza, con connessioni criptate, su server gestiti da primari fornitori in Europa.<br/>Non sei mai da solo: per qualunque suggerimento su come utilizzare il programma, saremo sempre a tua disposizione.",
            tipoContenuto: "png",
            urlContenuto: require("./immagini/sicurezzaSemplicitaAssistenza.png")
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>) 
    }

    if (props.pagina==="estrazione") {
        const titoloPagina = "Import / Export";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Importazione dei dati",
            descrizione: "Hai già i dati in formato elettronico? Gestione Sportiva può importarli automaticamente e noi possiamo darti supporto per farlo.<br/>Hai i dati in un altro gestionale ma non sai come estrarli? Possiamo aiutarti anche in questo caso!",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"importazione.png"
        },
        {
            titolo: "Estrazione dei dati",
            descrizione: "I dati sono tuoi e puoi scaricarli in ogni momento nel tuo PC.<br/>Le pagine che visualizzano le tabelle permettono di scaricare i dati in formato xlsx.<br/>Ci auguriamo che non vorrai più lasciarci, ma se lo vorrai fare potrai scaricare i tuoi dati in vari fogli elettronici, per poi usarli altrove: non dare per scontato che questo avvenga con tutti i software di questo genere.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"estrazione.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)
    }

    if (props.pagina==="personalizzazioni") {
        const titoloPagina = "Personalizzazioni";
        const sottotitoloPagina = "";
        const sezioni = [
        {
            titolo: "Personalizzazioni",
            descrizione: "Gestione Sportiva è un prodotto che si può adattare alle tue esigenze, che sono diverse da quelle degli altri.<br/>Aggiungere una ricerca, una tabella o un report, modificare una funzionalità, cambiare l'aspetto grafico:<br/>contattaci e valuteremo insieme come personalizzare la TUA Gestione Sportiva.",
            tipoContenuto: "png",
            urlContenuto: props.urlMultimedia+"personalizzazioni.png"
        }
        ]
        return (<PaginaSecondaria {...props} titoloPagina={titoloPagina} sottotitoloPagina={sottotitoloPagina} dimensioniApp={dimensioniApp} sezioni={sezioni}/>)              
    }

    if (props.pagina==="contatti") {
        return (
            <div className='App'>     
                <MenuAlto {...props} bottoneHome={true} dimensioniApp={dimensioniApp}/>
                <Intestazione {...props} titoloPagina="Contatti" dimensioniApp={dimensioniApp}/>
                Per informazioni commerciali scrivi a: <a href="mailto:info@gestionesportiva.it">info@gestionesportiva.it</a>
                <br/>
                <br/>
                Per richieste di assistenza scrivi a: <a href="assistenza@gestionesportiva.it">assistenza@gestionesportiva.it</a>
                <br/>
                <br/>
                In caso di emergenza (se non ricevi risposta dalle caselle sopra indicate) scrivi a: <a href="info@aigenova.it">info@aigenova.it</a>
                <br/>
                <br/>
                <FondoPagina {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>
            </div>
        )        
    }

    if (props.pagina==="privacy") {
        return (
            <div className='App'>     
                <MenuAlto {...props} bottoneHome={true} dimensioniApp={dimensioniApp}/>
                <Intestazione {...props} titoloPagina="Privacy" dimensioniApp={dimensioniApp}/>
                Questo sito non utilizza cookies di tracciamento o di profilazione dei visitatori.<br/>
                Le pagine che chiedono dati personali, come l'indirizzo email, richiedono che l'utente esprima (nella stessa pagina) un esplicito consenso per il trattamento e la memorizzazione di questi dati, che vengono utilizzati unicamente per fornire il servizio richiesto (ad esempio la prova gratuita dell'applicazione o l'acquisto) e non vengono in ogni caso ceduti a terzi.<br/>
                Per maggiori dettagli, consultare i seguenti documenti:
                <br/>
                <br/>
                <a href="https://gestionesportiva.it/documenti/AIG_GDPR.pdf">Documento trattamento dati</a>                
                <br/>
                <br/>
                <a href="https://gestionesportiva.it/documenti/AIG_GS_TERMCOND.pdf">Documento Termini e Condizioni</a>
                <br/>
                <br/>
                <FondoPagina {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>
            </div>
        )        
    }

    if (props.pagina==="condizioni") {
        return (
            <div className='App'>     
                <MenuAlto {...props} bottoneHome={true} dimensioniApp={dimensioniApp}/>
                <Intestazione {...props} titoloPagina="Termini e Condizioni" dimensioniApp={dimensioniApp}/>
                Il seguente documento descrive i Termini e le Condizioni per l'utilizzo di Gestione Sportiva:
                <br/>
                <br/>
                <a href="https://gestionesportiva.it/documenti/AIG_GS_TERMCOND.pdf">Documento Termini e Condizioni</a>
                <br/>
                <br/>
                <FondoPagina {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>
            </div>
        )        
    }

    if (props.pagina==="provaGratis") {
        return (<ProvaGratis {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>)                
    }

    if (props.pagina==="acquista") {
        return (<Acquista {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>)                
    }

    if (props.pagina==="prezzi") {
        return (<Prezzi {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>)                
    }

    if (props.pagina==="scaricaApp") {
        return (<ScaricaApp {...props}  produttore={produttore} dimensioniApp={dimensioniApp}/>)
    }

    if (props.pagina==="chiSiamo") {
        return (<ChiSiamo {...props}  produttore={produttore} dimensioniApp={dimensioniApp}/>)
    }

    if (props.pagina!=="home") {
        // pagina ancora da fare, visualizzo solo il layout
        return (
            <div  className='App'>
                <MenuAlto {...props} bottoneHome={true} dimensioniApp={dimensioniApp}/>
                <Intestazione {...props} dimensioniApp={dimensioniApp}/>
                <FondoPagina {...props} produttore={produttore} dimensioniApp={dimensioniApp}/>
            </div>
        )
    }

    return (
        <div style={{textAlign: "center", color:"#505050"}}>   
            
            <MenuAlto {...props} bottoneHome={false} dimensioniApp={dimensioniApp}/>
            
            
            <Intestazione {...props} isHome={true} dimensioniApp={dimensioniApp}/>
            <IntroHome {...props} vaiLink={vaiLink} />
            
            {/*
            <div style={{paddingTop:20, paddingBottom:20, color:"#909090", backgroundColor:"#F5F5F5", marginLeft:20, marginRight:20}}>      
               
                <video style={{height:300, maxWidth:dimensioniApp.x-40}} autoPlay loop muted webkit-playsinline="true" playsinline="true">
                <source src={props.urlMultimedia+"gestionesportivachat.mp4"} type="video/mp4"/>
                Il browser non supporta la riproduzione di video.
                </video>      

                <div style={{display:"flex", flexWrap: "wrap", justifyContent: "center", paddingTop:20}}>  
                    <div style={{color:"#FF4040", backgroundColor:"#FFFF00", cursor:"pointer", paddingLeft:20, paddingRight:20, paddingTop:10, paddingBottom:10}} onClick={() => vaiLink("/provaGratis")} ><b>Prova gratis</b> →</div>
                    <div style={{color:"#4040FF", cursor:"pointer", whiteSpace: "nowrap", paddingLeft:20, paddingRight:20, marginTop:10}} onClick={() => vaiLink("/scaricaApp")} >APP Iscritti →</div>
                    <div style={{color:"#4040FF", cursor:"pointer", paddingLeft:20, paddingRight:20, marginTop:10}} onClick={() => vaiLink("/acquista")}>Acquista →</div>
                    <div style={{color:"#4040FF", cursor:"pointer", paddingLeft:20, paddingRight:20, marginTop:10}}  onClick={() => window.location.href = props.urlServizio}>Accedi →</div>                    
                </div>
            </div>            

            {/*
            <div style={{lineHeight:2, marginTop:40, marginBottom:60}}>
                <span style={{fontSize:20, fontWeight:'bold'}}>Cos'è Gestione Sportiva?</span>
                <div style={{height:40}}></div>
                <div style={{display:'flex', justifyContent:'center'}}>
                <div>E' una web app per <span style={{fontSize:20, fontWeight:'bold'}}>computer, tablet e smartphone</span> sviluppata da</div>
                <a href='https://aigenova.it'><img style={{marginLeft:5, marginTop:-1}} src={logoAIG} height={40} alt="Azienda Informatica Genova"/></a>,
                </div>

                <div style={{justifyContent:'center', marginTop:-12}}>
                    consente alle <span style={{fontSize:20, fontWeight:'bold'}}>associazioni, società sportive e palestre</span> e agli <span style={{fontSize:20, fontWeight:'bold'}}>atleti</span>
                    <br/>
                    di gestire eventi, convocazioni, prenotazioni, schede allenamenti, abbonamenti, spese, incassi, bilancio, scadenze, comunicazioni, accessi...<br/>
                    ... ed è <span style={{fontSize:20, fontWeight:'bold'}}>personalizzabile</span> sulle <span style={{fontSize:20, fontWeight:'bold'}}>tue</span> esigenze.
                </div>
            </div>           
            */}

            {sezioniHome.map((sezione, index) => (
            <SezioneHome
                key={index}
                titolo={sezione.titolo}
                descrizione={sezione.descrizione}
                immagine={sezione.immagine}
                link={sezione.link}
                invertita={index % 2 === 1}
                delay={0.2}
            />
            ))}

            
            <FondoPagina {...props} produttore={produttore} pagina="principale" dimensioniApp={dimensioniApp}/>
        </div>
    );
}

export default PaginaPrincipale;